import TemplateNames from './TemplateNames';

export default {
  title: 'Wysłane wiadomości',
  columns: {
    recipient: 'Odbiorca',
    template: 'Szablon',
    status: 'Status',
    opened: 'Otwarto',
    clicked: 'Kliknięto',
    sent_at: 'Wysłano o',
  },
  labels: {
    empty_list: 'Brak wysłanych wiadomości',
    load_failed: 'Nie udało się wczytać wysłanych wiadomości. Odśwież stronę lub skontaktuj się z pomocą techniczną.',
    yes: 'Tak',
    no: 'Nie',
    clicked_at: 'Kliknięto: {{date}}',
    opened_at: 'Otwarto: {{date}}',
  },
  message_statuses: {
    sent: 'Wysłano',
    delivered: 'Dostarczono',
    failed: 'Błąd',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
